import * as React from "react";
import { createGenericContext, GetBemBlocksWith } from "@ebsco-ui/utils";
import type { PanelPlacement } from "../interfaces";

export interface PopoverContextType {
  getBlocksWith: GetBemBlocksWith;
  isOpen: boolean;
  uniqueName: string;
  buttonRef: React.MutableRefObject<HTMLButtonElement | null>;
  handleOnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  panelPlacement: PanelPlacement;
  panelRef: React.MutableRefObject<HTMLDivElement | null>;
  handleOnPanelBlur: React.FocusEventHandler<HTMLDivElement>;
  closePopover: () => void;
}

export const {
  useGenericContext: usePopoverContext,
  GenericContextConsumer: PopoverContextConsumer,
  GenericContextProvider: PopoverContextProvider,
} = createGenericContext<PopoverContextType>({
  errorMessage:
    "Popover compound components cannot be rendered outside the Popover component",
});
